/* eslint-disable @next/next/no-img-element */
import http from "utilities/http";
import ArticleComponent from "components/cong-dong/articleComponent";
import Paginate from 'components/home/paginate';
import { isEmpty } from "lodash";
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import { useEffect, useState } from "react";

export default function Index({ threads: threadsProp, profession }) {
    const perPage = 6;
    const [threadsPage, setThreadsPage] = useState([6, threadsProp.meta?.pagination?.total || 0]);
    const [threads, setThreads] = useState(threadsProp);

    const fetchReview = async (pageNumber) => {
        pageNumber = pageNumber || 1;
        const token = !isEmpty(getCookie(TOKEN_CONGDONG)) ? 'Bearer ' + getCookie(TOKEN_CONGDONG) : 'default';
        try {
            let url = `community/professional/${profession.id}/threads?page=${pageNumber}&per_page=${perPage}`;
            const response = await http(url, {}, { token: token }, 'v2');
            if (response.code == '200') {
                setThreads(response);
                setThreadsPage([perPage, response.meta?.pagination?.total || 0]);
                return;
            }
            setThreads(threadsProp);
            setThreadsPage([perPage, threadsProp.meta?.pagination?.total || 0]);
        } catch (e) {
            console.log(e.message);
        }
    };
    return (
        <>
            {
                !isEmpty(threads?.data) && <div className="list-wrap reviews">
                    <ul>
                        {threads?.data?.map((item, index) => {
                            return (
                                <ArticleComponent key={index} item={item} index={index} slug={'thao-luan'}></ArticleComponent>
                            );
                        })}
                    </ul>
                </div>
            }
            {!isEmpty(threads?.data) && <Paginate paginate={threadsPage} fetchData={fetchReview} scrollToEl="#reviews"></Paginate>}
            {
                isEmpty(threads?.data) && <div className="expert__wrap-content expert-voucher">
                    <div className="voucher-none">
                        <div className="thumb"><img src="/images/icon-no-data.svg" alt="" /></div>
                        <p className="text">Chưa có bài thảo luận nào</p>
                    </div>
                </div>
            }
        </>);
}